import script from "./AppNavCookieAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavCookieAccess.vue?vue&type=script&setup=true&lang=js"

import "./AppNavCookieAccess.vue?vue&type=style&index=0&id=a08e207e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a08e207e"]])

export default __exports__